import React from 'react';
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import { bool, func, number, string } from 'prop-types';

// Components
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

import { styled } from '@mui/material/styles';

const ArrowContainer = styled(ButtonBase)(({ theme }) => ({
  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.graphic.light}`,
    color: theme.palette.graphic.main,
  },
  border: '1px solid #C9C9C9',
  borderRadius: 5,
  color: theme.palette.primary.main,
  height: 32,
  width: 32,
}));

const RemoveIcon = styled(ButtonBase)(({ theme }) => ({
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: 5,
  },
  height: 28,
  marginLeft: theme.spacing(2),
  width: 28,
}));

const WizardRowItem = props => {
  const { index, length, name, onMove, onRemove, sequenceable } = props;
  const theme = useTheme();
  return (
    <Box
      alignItems="center"
      borderBottom={`1px solid ${theme.palette.graphic.light}`}
      display="flex"
      height={theme.spacing(7)}
      justifyContent="space-between"
      padding={theme.spacing(2, 3)}
    >
      <Typography variant="body1">{name}</Typography>
      <Box alignItems="center" display="flex">
        {sequenceable && (
          <Box display="flex" justifyContent="space-between" width={66}>
            <ArrowContainer
              disabled={index === 0}
              // Direction is a number to move the index in array - decrease array index for item
              onClick={() => onMove(index, -1)}
            >
              <ArrowDropUpRoundedIcon sx={{ fontSize: 32 }} />
            </ArrowContainer>
            <ArrowContainer
              disabled={index === length - 1}
              // Direction is a number to move the index in array - increase array index for item
              onClick={() => onMove(index, 1)}
            >
              <ArrowDropDownRoundedIcon sx={{ fontSize: 32 }} />
            </ArrowContainer>
          </Box>
        )}
        <RemoveIcon onClick={onRemove}>
          <CloseRoundedIcon sx={{ color: 'secondary.main' }} />
        </RemoveIcon>
      </Box>
    </Box>
  );
};

WizardRowItem.propTypes = {
  index: number,
  length: number,
  name: string.isRequired,
  onMove: func,
  onRemove: func.isRequired,
  sequenceable: bool,
};

WizardRowItem.defaultProps = {
  index: null,
  length: null,
  onMove: () => {},
  sequenceable: null,
};

export default WizardRowItem;
